import React from 'react';

import { SearchTextField, Avatar, PopoverMenu } from 'src/components/basic';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import Call from 'src/components/call';

import { withRouter, remCss, userFullName, permissions } from 'src/helpers';

import ContactsList from 'src/components/messages/ContactsList';
import model from 'src/components/messages/model';
import chatModel from 'src/components/messages/chat/model';

import { PatientInfoPanel, DoctorInfoPanel } from 'src/components/complex';

import filesModel from 'src/components/messages/filesModel';
import callModel from 'src/components/call/model';
import Chat from 'src/components/messages/chat';
import treatmentsModel from 'src/components/messages/treatmentsModel';
import BaseMessage from 'src/components/messages';
import { getUnavailableStateForNow } from 'src/helpers';
import { ActivityLabel } from 'src/components/user/LastActivity';

const list = [
  {
    label: 'Archive',
    isShow: (contact) => contact && !contact.archive,
    onClick: (contact) => model.setArchive(contact.partnerId, true)
  },
  {
    label: 'Unarchive',
    isShow: (contact) => contact && contact.archive,
    onClick: (contact) => model.setArchive(contact.partnerId, false)
  }
];

const { PAGES } = permissions;

class Message extends BaseMessage {
  constructor(props) {
    super(props);

    this.state = {
      hideInfo: false
    };
    model.changeTab('main_message', 'chat');
  }
  viewProfile = () => {
    let contactUser = model.state.contactUser;
    let url = PAGES.ADMIN_DOCTORS_DETAIL_PAGE.match(contactUser.username);
    if (!contactUser.isDoctor) {
      url = PAGES.ADMIN_PATIENTS_DETAIL_PAGE.match(contactUser.id);
    }
    this.navigate(url);
  };
  openLast = () => {
    let lastContact = model.items('recent')[0];
    if (lastContact) {
      model.openId(lastContact.partnerId);
      setTimeout(() => {
        this.navigate('/admin/messages/' + lastContact.partnerId);
      }, 1);
    } else if (model.getApiState('refresh').loading) {
      model.setStateSilent({ waitingOpenLast: true });
    }
  };

  render() {
    const { contactUser } = model.state;
    const callUUID = callModel.state.current;
    const { isCaller, callerId } = callModel.getListState(callUUID);
    const isCalling = callUUID && (isCaller || callerId == contactUser?.id);

    return (
      <div className={'mc-container-content mc-messages'}>
        <div
          className={'mc-container-content__header mc-flex-15'}
          style={{ width: '30%', maxWidth: remCss(330) }}
        >
          <SearchTextField
            inputTestId={'admin-messages-search-input'}
            width={330}
            template={'2'}
            onChange={model.handleChangeSearch2}
            value={model.listInput('search')}
          />
        </div>
        <div className={'mc-container-content__body horizontal'} style={{ position: 'relative' }}>
          <div
            className={'mc-container-content__body-left mc-b2r'}
            style={{ maxWidth: remCss(330), minWidth: remCss(330) }}
          >
            <ContactsList isAdminPage={true} />
          </div>
          <div
            className={'mc-container-content__body-center'}
            data-testid={'messages-chat-panel'}
            style={{ minWidth: remCss(510) }}
          >
            <div className={'mc-header ' + (isCalling ? 'has-calling' : '')}>
              <Call />
              {contactUser && (
                <div className={'mc-flex mc-p20 mc-flex-start'}>
                  <Avatar
                    image={(contactUser?.avatar || '').replace('/full_', '/350_')}
                    width={50}
                    height={50}
                    text={userFullName(contactUser)}
                    onlineState={
                      getUnavailableStateForNow(contactUser?.accountState)
                        ? 'not_available'
                        : contactUser?.partnerOnline > 0
                          ? 'online'
                          : ''
                    }
                  />
                  <div className={'mc-flex-5-col mc-grow'}>
                    <div className={'mc-value-520'}>
                      {userFullName(contactUser, contactUser.isDoctor)}
                    </div>
                    <div className={'mc-label-516'} data-testid={'message-contact-status'}>
                      <ActivityLabel
                        accountState={contactUser?.accountState}
                        lastActivity={contactUser?.lastActivity}
                        connections={contactUser?.partnerOnline}
                      />
                    </div>
                  </div>
                  <div className={'mc-flex-10'} style={{ height: remCss(40) }}>
                    <button type='button' className={'mc-no-style-btn'} onClick={this.toggleSearch}>
                      <SVGIcon iconname={BASE_ICONS.SEARCH} width={40} />
                    </button>
                    {!isCalling && (
                      <button type='button' className={'mc-no-style-btn'} onClick={this.startCall}>
                        <SVGIcon iconname={BASE_ICONS.VIDEO} width={40} />
                      </button>
                    )}
                    <PopoverMenu
                      placement={'bottom-end'}
                      menu={(close) => (
                        <ul
                          className={'mc-select-field-items'}
                          style={{
                            backgroundColor: 'white',
                            padding: remCss(10)
                          }}
                        >
                          {list
                            .filter((item) => item.isShow(contactUser, model.state.user))
                            .map((item) => (
                              <li
                                key={item.label}
                                onClick={() => {
                                  if (item.onClick) {
                                    item.onClick(contactUser);
                                  } else {
                                    this.setOption(item);
                                  }
                                  close();
                                }}
                              >
                                <div className={'mc-p15 mc-pointer'}>
                                  <div className={'mc-value-520'}>{item.label}</div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      )}
                      className={'mc-no-style-btn'}
                    >
                      {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={40} />}
                    </PopoverMenu>
                    {model.state.hideInfo && (
                      <button
                        type='button'
                        className={'mc-no-style-btn'}
                        onClick={() => this.openRightSlide()}
                      >
                        <SVGIcon iconname={BASE_ICONS.PERSONAL_INFORMATION} width={40} />
                      </button>
                    )}
                  </div>
                </div>
              )}
              {model.state.enableSearch ? (
                <div className={'mc-search-chat-box mc-p10'}>
                  <SearchTextField
                    placeholder={'Search in chat'}
                    onChange={(t) => {
                      model.listHandleChange('search_chat', t);
                      chatModel.handleChangeSearch(t);
                    }}
                    hideSearchFn={this.toggleSearch}
                    value={model.listInput('search_chat')}
                  />
                </div>
              ) : (
                <div className={'mc-line'} />
              )}
            </div>
            {contactUser && (
              <div className={'mc-tab-box-opacity mc-grow'}>
                <div className={'mc-tab-content mc-flex-0-col'}>
                  <Chat treatmentsModel={treatmentsModel} />
                </div>
              </div>
            )}
          </div>
          <div
            ref={this.rightSliderRef}
            className={
              'mc-container-content__body-right ' +
              (model.state.hideInfo ? 'animate-close' : 'animate-open')
            }
            style={{
              maxWidth: remCss(300),
              position: 'absolute',
              right: '0px',
              zIndex: 100000,
              backgroundColor: 'white'
            }}
          >
            {contactUser &&
              (contactUser.isDoctor ? (
                <DoctorInfoPanel
                  {...contactUser}
                  doctor={contactUser}
                  closeBtn={() => this.closeRightSlide()}
                  viewProfile={this.viewProfile.bind(this, '')}
                />
              ) : (
                <PatientInfoPanel
                  patient={{ ...contactUser?.partnerProfile, id: contactUser.id }}
                  viewProfile={this.viewProfile.bind(this, '')}
                  closeBtn={() => this.closeRightSlide()}
                  model={filesModel}
                />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Message);
